import { createSlice } from '@reduxjs/toolkit';

import { User } from '../types/user';

const initialState: User = {
  id: 0,
  email: '',
  accessToken: '',
  isAdmin: false,
  permissions: [],
  permissionsHash: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signInUser(_state, action: { payload: User }) {
      return { ...initialState, ...action.payload };
    },
    signOutUser() {
      return { ...initialState };
    },
    setPermissions(state, action: { payload: { permissions: string[]; hash: string } }) {
      return {
        ...state,
        permissions: action.payload.permissions,
        permissionsHash: action.payload.hash,
      };
    },
    updateAccessToken(state, action: { payload: string }) {
      return {
        ...state,
        accessToken: action.payload,
      };
    },
  },
});

export const { signInUser, signOutUser, setPermissions, updateAccessToken } = userSlice.actions;
export default userSlice.reducer;
